import React, { FC, useState } from 'react';
import { IconButton, InputAdornment, Input } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { colorSet } from 'src/theme';

interface IProps {
  data: string;
  setData: (event: string) => void;
  error?: string;
  check?: boolean;
  title: string;
  placeholder?: string;
  style?: {};
}

const PasswordInput: FC<IProps> = ({ data, setData, error, check, title, placeholder, style }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <div style={style}>
      {title && (
        <div
          className='filter__title'
          style={{ marginBottom: '3px' }}
        >
          {title}
        </div>
      )}
      <Input
        type={showPassword ? 'text' : 'password'}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        value={data}
        onChange={(e) => setData(e.target.value)}
        error={!!error}
        inputProps={{ maxLength: 15 }}
        placeholder={placeholder}
        autoComplete='new-password'
        sx={{
          width: '100%',
          input: {
            '::placeholder': {
              color:
                check && !data ? colorSet.primaryRed : colorSet.primaryGrey,
              opacity: 1,
            },
          },
        }}
      />
    </div>
  );
};

export default PasswordInput;
